import React, { useEffect, useState, useContext } from "react";
import { DropdownMultiHover } from "@reusejs/react";
import { ChevronDownIcon } from "@heroicons/react/outline";
import { HeaderNavItems, Context } from "services";
import { useRouter } from "next/router";
import Link from "next/link";

export default function Navigations(props: any) {
  const router = useRouter();
  const { searchForm }: any = useContext(Context);
  const [navigationItems, setNavigationItems] = useState<any>();

  const getNavigationItems = async () => {
    const data: any = HeaderNavItems();
    setNavigationItems(data);
  };

  useEffect(() => {
    getNavigationItems();
  }, []);

  return (
    <div>
      <div className="hidden lg:flex h-full justify-center space-x-8">
        {navigationItems?.main.map((navItem: any, index: number) => {
          if (navItem.dropdown === true) {
            return (
              <div className="flex" key={index}>
                <div className="relative flex">
                  <DropdownMultiHover
                    dropdownMultiHoverClasses={{
                      containerClasses:
                        navItem?.value === "properties"
                          ? "absolute z-20 top-6 left-0 w-52 origin-top-left border dark:border-gray-800 bg-white dark:bg-gray-900 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none  rounded-md"
                          : "absolute z-20 top-6 left-0 w-72 origin-top-left border dark:border-gray-800 bg-white dark:bg-gray-900 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none  rounded-md",
                      childContainerClasses:
                        "absolute z-20 -top-1  w-60 right-0 origin-top-left translate-x-full border dark:border-gray-800 bg-white dark:bg-gray-900 py-1 rounded-md",
                      itemClasses:
                        "relative block w-full cursor-pointer px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-blue-600 dark:text-gray-100 dark:hover:bg-gray-700",
                      transition: {
                        enter: "transition ease-out duration-200",
                        enterFrom: "transform opacity-0 scale-95",
                        enterTo: "transform opacity-100 scale-100",
                        leave: "transition ease-in duration-75",
                        leaveFrom: "transform opacity-100 scale-100",
                        leaveTo: "transform opacity-0 scale-95",
                      },
                    }}
                    label={() => (
                      <span className="relative z-10 -mb-px flex items-center border-b-2 border-transparent pt-px text-sm font-medium text-gray-700 transition-colors duration-200 ease-out hover:text-blue-600">
                        {navItem?.label}{" "}
                        <ChevronDownIcon height="16" width="16" />
                      </span>
                    )}
                    items={
                      navItem?.value === "properties"
                        ? navigationItems?.properties
                        : navigationItems?.services
                    }
                    onClick={(item, index) => {
                      if (navItem?.value === "properties") {
                        searchForm.setField("asset_type", "");
                        searchForm.setField("sub_asset_type", "");
                        searchForm.setField("state", "");
                        searchForm.setField("city", "");
                        searchForm.setField("reserve_price", "");
                        searchForm.setField("institutes", "");
                        searchForm.setField("filter_by", "");
                        searchForm.setField("sort_by", "");
                        searchForm.setField("total", "");
                        if (router.asPath.match("auction-properties")) {
                          router.push(item?.href).then(() => router.reload());
                        } else {
                          router.push(item?.href);
                        }
                      } else {
                        router.push(item?.href);
                      }
                    }}
                  />
                  <div className="hidden">
                    <Link key={index} href={navItem.link}>
                      {navItem.label}
                    </Link>
                  </div>
                </div>
              </div>
            );
          } else {
            return (
              <Link key={index} href={navItem?.link}>
                <a className="flex items-center text-sm font-medium text-gray-700 hover:text-blue-600">
                  {navItem?.label != "Profile" ? navItem?.label : ""}
                </a>
              </Link>
            );
          }
        })}
      </div>
    </div>
  );
}
